import { GetAlertsWithHandlebars } from './Alerts/Alerts'
import usaj_ga from './Analytics/usaj-analytics'

var controlnum = "";
var announcementnum = "";
$(document).ready(function () {
    $(document).on("click", ".user-logged-out", function (e) {
        e.preventDefault();
        var redirectURL = "";
        var joaParameters = window.location.search !== "" ? window.location.search + "&auth=true" : "?auth=true";

        redirectURL = window.location.protocol + "//" + window.location.host + window.location.pathname + "/Authenticate" + window.location.search;

        window.location.href = redirectURL;
    });

    controlnum = $("#ControlNumber").val();
    announcementnum = $("#AnnouncementID").val();
    $("#lnk-agency-contact").bind('click', function () {
        goToByScroll("agencycontact");
        return false;
    });

    $(".viewmap").click(function () {
        var lat = $(this).data("coord-lat");
        var long = $(this).data("coord-long");
        var title = $.trim($("#jobtitle").text());
        var name = $(this).data("name");
        getMapCoordinates(lat, long, title, name);

    });



    $(".saveJobButton").bind('click', function (e) {
        e.preventDefault();
        SaveJob($(this));
        var userObject = JSON.parse(sessionStorage.getItem('userObject') ?? "");
        if (userObject && userObject.UniqueSearch) {
            usaj_ga.log_search_conversion_event(userObject, "search_conversion_save");
        }
    });

    $('#show-all-locations').click(function () {
        goToByScroll("btn-more-locations");
        return false;
    });

    $("#lnkHiringPaths").click(function () {
        goToByScroll("hiring-paths");
        return false;
    });

    if (!document.referrer || document.referrer.toLowerCase().indexOf("/search") === -1 && document.referrer.toLowerCase().indexOf("/job") === -1 && document.referrer.toLowerCase().indexOf("/coronavirus") === -1) {
        $('.usajobs-joa-prev-next__body').html('');
    }

    var userObject = JSON.parse(sessionStorage.getItem('userObject'));
    if (!userObject || !userObject.SearchResults || !userObject.SearchResults.Results) {
        $('.usajobs-joa-prev-next__body').html('');
    }

    hidePreviousLink();
    hideNextLink();

    $(document).on("click", ".beta-feedback", function () {
        $("svg.beta-feedback").not(this).css("color", "grey");
        $(this).css("color", "blue");
        if ($(this).hasClass("fa-thumbs-up")) {
            $("#isPositive").val("true");
        } else {
            $("#isPositive").val("false");
        }
    });

    $(document).on("click", ".submit-feedback", function () {
        $.post("/Applicant/Feature/Feedback", {
            featureName: $('#featureName').val(),
            isPositive: $('#isPositive').val(),
            remarks: $('#remarks').val()
        }).then(function () {
            $('#betaversion').html("<p>Thank you for the feedback!");
        })
    });
    GetAlertsWithHandlebars("PositionAlert", "Position");
});

$(document).on("click", "#previous-joa", function () {
    var userObject = JSON.parse(sessionStorage.getItem('userObject'));
    var page = userObject.SearchResults.Params.Page;
    var url = window.location.href;
    var currentJob = getCurrentJobID();
    var jobsList = userObject.SearchResults.Results.Items;
    var jobPOS = jobsList.indexOf(currentJob);
    var previousJob = jobsList[jobPOS - 1];
    if (previousJob !== undefined) {
        var newUrl = window.location.href.replace(currentJob, previousJob);
        newUrl = newUrl.replace(window.location.hash, "");
        window.location.href = newUrl;
        var currentPage = getCurrentPage(previousJob);
        userObject.SearchResults.Params.Page = currentPage;
        sessionStorage.setItem('userObject', JSON.stringify(userObject));
    }
    else if (page === 1) {
        $("#previous-joa").css("visibility", "hidden");
    }
    else if (page > 1) {
        getJobsFromIndex(userObject.SearchResults.Params, page - 1, function (result) {
            jobsList = result.concat(jobsList);
            userObject.SearchResults.Results.Items = jobsList;
            userObject.SearchResults.Params.Page = parseInt(page) - 1;
            var p2 = { Page: parseInt(page) - 1, PageItems: result };
            userObject.SearchResults.Results.PageSets.push(p2);
            sessionStorage.setItem('userObject', JSON.stringify(userObject));
            jobPOS = jobsList.indexOf(currentJob);
            previousJob = jobsList[jobPOS - 1];
            var newUrl = window.location.href.replace(currentJob, previousJob);
            newUrl = newUrl.replace(window.location.hash, "");
            window.location.href = newUrl;
        });
    }
});

$(document).on("click", "#back-to-results", function () {
    var currentPage, newPage, params;
    var userObject = JSON.parse(sessionStorage.getItem('userObject'));
    var page = userObject.SearchResults.Params.Page;
    if (page === 0 || page === undefined) {
        page = 1;
    }
    var url = userObject.SearchResults.Results.ReturnUrl;
    if (/&p=/i.test(url)) {
        params = url.split("&");
        for (var i = 0; i < params.length; i++) {
            if (/p=/i.test(params[i]) && !/hp/i.test(params[i])) {
                currentPage = params[i];
                newPage = "p=" + page;
                url = url.replace(currentPage, newPage);
            }
        }
    }
    else {
        url = url + "&p=" + page;
    }
    window.location.href = url;
});

$(document).on("click", "#next-joa", function () {
    var currentPage;
    var userObject = JSON.parse(sessionStorage.getItem('userObject'));
    var url = window.location.href;
    var currentJob = getCurrentJobID();
    var jobsList = userObject.SearchResults.Results.Items;
    var jobPOS = jobsList.indexOf(currentJob);
    var nextJob = jobsList[jobPOS + 1];
    if (nextJob === undefined) {
        currentPage = userObject.SearchResults.Params.Page;
        if (currentPage === 0 || currentPage === undefined) currentPage = 1;
        var nextPage = parseInt(currentPage) + 1;
        getJobsFromIndex(userObject.SearchResults.Params, nextPage, function (result) {
            jobsList = jobsList.concat(result);
            userObject.SearchResults.Results.Items = jobsList;
            userObject.SearchResults.Params.Page = nextPage;
            jobPOS = jobsList.indexOf(currentJob);
            nextJob = jobsList[jobPOS + 1];
            var p2 = { Page: nextPage, PageItems: result };
            userObject.SearchResults.Results.PageSets.push(p2);
            sessionStorage.setItem('userObject', JSON.stringify(userObject));
            var newUrl = window.location.href.replace(currentJob, nextJob);
            newUrl = newUrl.replace(window.location.hash, "");
            window.location.href = newUrl;
        });
    }
    else {
        var newUrl = window.location.href.replace(currentJob, nextJob);
        newUrl = newUrl.replace(window.location.hash, "");
        window.location.href = newUrl;
        currentPage = getCurrentPage(nextJob);
        userObject.SearchResults.Params.Page = currentPage;
        sessionStorage.setItem('userObject', JSON.stringify(userObject));
    }
});

$(document).on("click", ".locations-show-more", function () {
    var currentText = $(this).html();
    var parentList = $(this).closest("ul");
    var showCount = Number($("#MoreLocationsCount").val());
    var showMoreText = "Show more locations (" + showCount + ")";
    var showLessText = "Show fewer locations (" + showCount + ")";
    if (currentText === showMoreText) {
        $(parentList).find(".joa-additional-locations").show();
        $(this).html(showLessText);
        goToByElement(parentList);
    }
    else {
        $(parentList).find(".joa-additional-locations").hide();
        $(this).html(showMoreText);
        goToByElement(parentList);
    }
});

$(document).on("click", ".usajobs-joa-occupation__link", function () {
    if (usaj_ga) {
        usaj_ga.log_event_with_timeout("joa_soc_link", "click", $.trim($(this).html()));
    }
});

$(document).on("click", ".usajobs-joa-occupations__series", function () {
    if (usaj_ga) {
        usaj_ga.log_event_with_timeout("joa_series_link", "click", $.trim($(this).html()));
    }
});

$(document).one("session-loaded", function () {
    var controlNumber = $("#ControlNumber").val();
    var userObject = JSON.parse(sessionStorage.getItem('userObject'));
    displaySaveButton(userObject, controlNumber);
    displayApplyButton(userObject, controlNumber);
})

function displaySaveButton(userObject, controlNumber) {
    if (controlNumber in userObject.SavedJobs) {
        $(".saveJobButton").attr("data-state", "is-saved");
        $(".saveJobButton").html("Saved");
    } else {
        $(".saveJobButton").attr("data-state", "is-unsaved");
        $(".saveJobButton").html("Save");
    }
}

function displayApplyButton(userObject, controlNumber) {
    var IsAuthenticated = userObject && userObject.IsAuthenticated ? true : false;
    const applyButton = $('.usajobs-joa-actions__apply');
    if (applyButton) {
        if (IsAuthenticated) {
            $.get("/job/" + controlNumber + "/applytext", function (data) {
                applyButton.html(data);
            });
        } else {
            applyButton.text("Apply");
        }
        applyButton.removeClass("usaj-hidden");
        applyButton.on('click', () => usaj_ga.log_search_conversion_event(userObject, "search_conversion_apply"));
    }
}

function getCurrentJobID() {
    var urlPath = window.location.pathname;
    var docID = urlPath.split("/").pop();
    return docID;
}

function getJobsFromIndex(p, page, callback) {
    p.Page = page;
    jQuery.ajax({
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        url: '/Search/ExecuteNextSearch',
        data: JSON.stringify(p),
        type: 'POST',
        cache: false,
        success: function (data) {
            callback(data);
        }
    });
}

function hidePreviousLink() {
    var userObject = JSON.parse(sessionStorage.getItem('userObject'));
    if (userObject && userObject.SearchResults !== undefined && userObject.SearchResults !== null) {
        var currentPage = userObject.SearchResults.Params.Page;
        if (currentPage === 0 || currentPage === undefined) currentPage = 1;
        var currentJob = getCurrentJobID();
        var jobsList = userObject.SearchResults.Results.Items;
        var jobPOS = jobsList.indexOf(currentJob);
        var previousJob = jobsList[jobPOS - 1];
        if (previousJob === undefined && Number(currentPage) === 1) {
            $("#previous-joa").css("visibility", "hidden");
        }
    }

}

function hideNextLink() {
    var userObject = JSON.parse(sessionStorage.getItem('userObject'));
    if (userObject && userObject.SearchResults !== undefined && userObject.SearchResults !== null) {
        var currentPage = userObject.SearchResults.Params.Page;
        if (currentPage === undefined) currentPage = "1";
        var totalJobs = userObject.SearchResults.Results.ResultCount;
        var totalPages = Math.ceil(totalJobs / userObject.SearchResults.Params.ResultsPerPage);
        var jobPOS = userObject.SearchResults.Results.Items.indexOf(getCurrentJobID());
        if (totalPages === Number(currentPage) && jobPOS + 1 === userObject.SearchResults.Results.Items.length) {
            $("#next-joa").css("visibility", "hidden");
        }
    }
}

function getCurrentPage(jobID) {
    var userObject = JSON.parse(sessionStorage.getItem('userObject'));
    var page;
    for (var i = 0; i < userObject.SearchResults.Results.PageSets.length; i++) {
        if (userObject.SearchResults.Results.PageSets[i].PageItems.indexOf(jobID) >= 0)
            page = userObject.SearchResults.Results.PageSets[i].Page;
    }
    return page;
}

function goToByScroll(id) {
    $('html,body').animate({
        scrollTop: $("#" + id).offset().top
    }, 'slow');
}

function goToByElement(element) {
    $('html,body').animate({
        scrollTop: $(element).offset().top
    }, 'slow');
}

function SaveJob(el) {
    var docID = $("#ControlNumber").val();
    if (el.attr("data-state") === "is-unsaved") {
        var urlStr = encodeURI("/Search/QuickSave/") + docID;
        jQuery.ajax({
            type: 'GET',
            url: urlStr,
            async: true,
            success: function (data) {
                checkResult(data, docID);
            },
            error: function (xhr, err) {
            },
            cache: false
        });
    } else {
        $.post("/Applicant/Profile/DeleteSavedJob",
            { job: docID }).done(function () {
                checkResult("Job deleted", docID);
                removeSavedJobsInSession(docID);
            });
    }
}

function checkResult(a, id) {
    if (a === 'logged-out') {
        var reURL = encodeURI("/Applicant/Profile/QuickSave/") + id;
        window.location = reURL;
    } else if (a === 'Job successfully saved.') {
        $('.saveJobButton').text("Saved");
        $('.saveJobButton').attr("data-state", "is-saved");
        addSavedJobsInSession(id);
    } else if (a === "Job deleted") {
        $('.saveJobButton').text("Save");
        $('.saveJobButton').attr("data-state", "is-unsaved");
    } else {
        alert(a);
    }
}
